import { Stack, TextInput } from "@mantine/core";

export const AddToNewDeal = ({
  onChange,
  value,
}: {
  onChange: (value: string) => void;
  value: string;
}) => {
  return (
    <Stack gap={"xs"}>
      <TextInput
        label="Deal Name"
        value={value}
        onChange={(e) => onChange(e.currentTarget.value)}
        placeholder="New Deal Name"
      />
    </Stack>
  );
};
